exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".content{padding:20px;position:relative}.copy-button{position:absolute;top:25px;right:25px}#csv{font-family:monospace;white-space:pre;width:100%;height:100%;overflow:auto;border:1px solid #999;padding:30px 8px 10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6a757544","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/CSV.vue
// module id = 156
// module chunks = 0